import conf from '../config/api.js';
import Vue from 'vue';
var moment = require('moment');
//var htmlEncode = require('js-htmlencode').htmlEncode;
var htmlDecode = require('js-htmlencode').htmlDecode;

//Fonction génération de toaster erreur
function toasterError(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'error',
        position: 'bottom-right'
    })
}

//Fonction génération de toaster réussite
function toasterSuccess(content, title){
	new Vue().$notify({
        title: title,
        message: content,
        type: 'success',
        position: 'bottom-right'
    })
}

//fonction de récupération des fichier export je pilote
async function getExportVenteJePilote(dir, extn){
	try {
        let response = await requestApi({method: 'GET', url: '/api/getExportVenteJePilote?nocache=' + new Date().getTime(), params: {path: dir, ext: extn}, form: {name:name}, headers: {'Content-Type': 'application/json'}})
		let arrayReverse = response.reverse()
		let i = 0
		let result = []
		while (i < Math.ceil(arrayReverse.length/10)){
			let j = 0
			let pagination = []
			while (j < 10){
				if(arrayReverse[i*10+j]){
					pagination.push(arrayReverse[i*10+j])
				}
				j++
			}
			result.push(pagination)
			i++
		}
		this.dataExport = result
		this.dataExportLength = arrayReverse.length
	} catch (error) {
        if(error.response != undefined){
			toasterError(`Impossible de charger les exports`,'Export CSV')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
    }
}

//fonction de suppression d'export je pilote
async function delExportVenteJePilote(name){
	try {
        await requestApi({method: 'POST', url: '/api/delExportVenteJePilote?nocache=' + new Date().getTime(), params: {}, form: {name:name}, headers: {'Content-Type': 'application/json'}})
		toasterSuccess(`Suppression réussie`,'Suppression CSV')
	} catch (error) {
        if(error.response != undefined){
			toasterError(`Impossible de supprimer l'export`,'Suppression CSV')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
    }
}

//fonction de génération de fichier csv
async function generateCsv(date){
	try {
        await requestApi({method: 'POST', url: '/api/generateCsv?nocache=' + new Date().getTime(), params: {}, form: {date:date}, headers: {'Content-Type': 'application/json'}})
		toasterSuccess(`Génération réussie`,'Génération CSV')
	} catch (error) {
        if(error.response != undefined){
			toasterError(`Impossible de générer l'export`,'Génération CSV')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
    }
}

//Fonction de récupération des bons de prélèvements
async function getPrelevementBons(){
	try {
        let response = await requestApi({method: 'GET', url: '/api/getPrelevementBons?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		let result = []
		response.forEach(bon => {
			result.push({label:bon.ref,value:bon.rowid})
		})
		this.dataExport = result
		this.data = response
	} catch (error) {
        if(error.response != undefined){
			toasterError(`Impossible de récupérer les bons de prélèvement`,'Bons de prélèvement')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
    }
}

//Fonction de récupération des bons de prélèvements
async function generateExportBons(id,dateCred,nomBon){
	try {
        let name = await requestApi({method: 'GET', url: '/api/getExportPrelevement?nocache=' + new Date().getTime(), params: {id:id,dateCred:dateCred,nomBon:nomBon}, form: {}, headers: {'Content-Type': 'application/json'}})
    	// await requestApi({method: 'GET', url: '/api/downloadExportPrelevement/'+name+'?nocache=' + new Date().getTime(), params: {}, form: {}, headers: {'Content-Type': 'application/json'}})
		var element = document.createElement('a')
		element.setAttribute('href', '/api/downloadExportPrelevement/'+name)

		element.style.display = 'none'
		document.body.appendChild(element)

		element.click()

		document.body.removeChild(element)
	} catch (error) {
        if(error.response != undefined){
			toasterError(`Impossible de récupérer les lignes du bon de prélèvement`,'Lignes des bons')
		}else{
			toasterError(`Le service est momentanément indisponible`,'Service indisponible')
		}
    }
}

// Fonction appel api
/*
  args: options : method -- required
                  url -- required
                  params -- optional -- url parameters
                  form -- optional -- request body applicable only with PUT, POST and Patch methods
                  headers -- optional
*/
function requestApi (options) {
	return new Promise((resolve, reject) => {
		new Vue().axios({
			method: options.method,
			url: conf.server + options.url,
			params: options.params,
			data: options.form,
			headers: options.headers,
			withCredentials: true
		}).then((response) => {
			resolve(response.data)
		}).catch((error) => {
			reject(error)
		})
	})
}

export default{
	getExportVenteJePilote,
	delExportVenteJePilote,
	generateCsv,
	toasterError,
	toasterSuccess,
	getPrelevementBons,
	generateExportBons,
}

